import { saveOrShareBlob } from '@/lib/nativeFile';
import { estilizarCabecalho, autoWidth } from '@/lib/excelStyle';

/**
 * Modelo .xlsx do cadastro inteligente (POST /api/cadastro-inteligente/importar): uma linha por pessoa.
 * Regras: docs/cadastro-inteligente-2026-11-01.md.
 */
export const COLUNAS_CADASTRO_INTELIGENTE = ['nome', 'email', 'departamento', 'cargo', 'gestor_email', 'perfil'];

const INSTRUCOES = [
  'Uma linha por pessoa. nome e email são obrigatórios; as outras colunas são opcionais.',
  'departamento e cargo: os que não existirem na empresa são criados (em maiúsculo). O cargo novo fica no departamento da linha.',
  'gestor_email: e-mail do gestor direto. Pode ser alguém desta planilha (em qualquer linha) ou alguém que já usa o Kora na empresa.',
  'perfil: admin ou usuário (vazio = usuário).',
  'Pode usar a sua própria planilha: cabeçalhos como E-mail, Setor, Função e E-mail do gestor também são reconhecidos.',
  'Cada pessoa nova recebe um e-mail para definir a própria senha (link válido por 7 dias).',
  'E-mail que já está cadastrado nesta empresa não é alterado: a linha aparece como erro.',
  'Antes de gravar, o Kora mostra uma prévia com tudo o que será criado e os erros de cada linha.',
  'Até 500 linhas por arquivo. Formatos: .xlsx ou .csv.',
];

export async function baixarModeloCadastroInteligente(): Promise<void> {
  // Carregado sob demanda: o exceljs só entra quando alguém baixa o modelo.
  const ExcelJS = (await import('exceljs')).default;
  const workbook = new ExcelJS.Workbook();

  const aba = workbook.addWorksheet('Equipe');
  aba.columns = COLUNAS_CADASTRO_INTELIGENTE.map((key) => ({ header: key, key }));
  aba.addRow({ nome: 'Ana Souza', email: 'ana@suaempresa.com', departamento: 'Comercial', cargo: 'Gerente comercial', gestor_email: '', perfil: 'admin' });
  aba.addRow({ nome: 'Bruno Lima', email: 'bruno@suaempresa.com', departamento: 'Comercial', cargo: 'Vendedor', gestor_email: 'ana@suaempresa.com', perfil: 'usuário' });
  aba.addRow({ nome: 'Carla Dias', email: 'carla@suaempresa.com', departamento: 'Financeiro', cargo: 'Analista financeiro', gestor_email: 'ana@suaempresa.com', perfil: '' });
  estilizarCabecalho(aba);
  autoWidth(aba, { nome: 24, email: 28, departamento: 18, cargo: 24, gestor_email: 28, perfil: 10 });

  const instrucoes = workbook.addWorksheet('Instruções');
  instrucoes.columns = [{ header: 'Como preencher', key: 'texto', width: 120 }];
  INSTRUCOES.forEach((texto) => instrucoes.addRow({ texto }));
  estilizarCabecalho(instrucoes);

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  await saveOrShareBlob(blob, 'modelo_cadastro_inteligente.xlsx');
}
